import React, { Suspense, lazy, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import axios from "axios";
import "./utilities/axios";
import Loading from "./components/Loading";
import { SwitchScreenProvider } from "./hooks/SwitchScreenContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { env } from "./utilities/function";
import Sign from "./pages/ESign/Sign";
import OtherSigner from "./components/OtherSigner";
import CompletedDocuments from "./pages/document/Completed";
import AwaitedDocuments from "./pages/document/Awaited";
import VoidedDocuments from "./pages/document/Voided";
import DraftDocuments from "./pages/document/Draft";
import TrashDocuments from "./pages/document/Trash";
import ReceivedDocuments from "./pages/document/Received";
import FormTemplate from "./pages/Template/FormTemplate";
import Template from "./pages/Template";
import Documents from "./pages/document";
import PreviewDocuments from "./components/PreviewDocument/PreviewDocuments";
import Navbar from "./components/Navbar";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import SignupTrial from "./pages/SignupTrial";
import SignupTrialWork from "./pages/SignupTrialWork";
import TrialActivation from "./pages/TrialActivation";
import TrialActivationWork from "./pages/TrialActivationWork";
import ThemeContextProvider from "./style/theme";
import { useTheme } from "./style/theme";
import { setCookie } from "./utilities/cookies";

const Header = lazy(() => import("./components/Header"));

const storedUser = JSON.parse(localStorage.getItem("user"));
const AppRoutes = () => {
  const { mode } = useTheme();

  useEffect(() => {
    const htmlElement = document.documentElement;

    if (mode === "dark") {
      htmlElement.classList.add("dark");
    } else {
      htmlElement.classList.remove("dark");
    }
  }, [mode]);

  return (
    <Routes>
      <Route path="/othersigner" element={<OtherSigner />} />
      <Route path="/register/trialactivate" element={<TrialActivation />} />
      <Route path="/register/trialactivate1" element={<TrialActivationWork />} />

      {!storedUser || !storedUser._id ? (
        <>
          <Route path="/register" element={<SignupTrial />} />
          <Route path="/register1" element={<SignupTrialWork />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="*" element={<Navigate to="/signup" />} />
        </>
      ) : (
        <Route
          path="*"
          element={
            <Navbar>
              <Routes>
                <Route path="/" element={<Sign />} />
                <Route path="/sign" element={<Sign />} />
                <Route path="/documents" element={<Documents />} />
                <Route
                  path="/documents/completed"
                  element={<CompletedDocuments />}
                />
                <Route
                  path="/documents/awaiting"
                  element={<AwaitedDocuments />}
                />
                <Route path="/documents/voided" element={<VoidedDocuments />} />
                <Route path="/documents/draft" element={<DraftDocuments />} />
                <Route
                  path="/documents/received"
                  element={<ReceivedDocuments />}
                />
                <Route path="/documents/preview" element={<PreviewDocuments />} />
                <Route path="/documents/trash" element={<TrashDocuments />} />
                <Route path="/templates" element={<Template />} />
                <Route path="/templates/new" element={<FormTemplate />} />
                <Route path="/templates/:id" element={<FormTemplate />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Navbar>
          }
        />
      )}
    </Routes>
  );
};

const App = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(storedUser || null);

  const showMessage = (payload) => {
    if (typeof window.showMessage === "function") {
      // window.showMessage(payload);
      return;
    }
    if (payload && payload.success) {
    } else if (payload && payload.error) {
    } else {
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const userId = params.get("userId");

    const handleUserLoginById = async (userIdParam) => {
      try {
        setLoading(true);

        const profileRes = await axios.post(
          "https://accounts.clikkle.com:5000/api/auth/get_user_profile",
          { id: userIdParam }
        );
        const profileData = profileRes.data;

        if (!profileData?.user) {
          setLoading(false);
          return;
        }

        setUser(profileData.user);
        localStorage.setItem("user", JSON.stringify(profileData.user));

        setCookie("userId", profileData.user._id);
        setCookie("fullName", profileData.user.username);
        setCookie("role", profileData.user.role);

        showMessage({ success: "Login successful!" });

        window.location.href = "/";
      } catch (err) {
        console.error("Error in handleUserLoginById:", err);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      handleUserLoginById(userId);
    }
  }, []);

  return (
    <SwitchScreenProvider>
      <Suspense fallback={<Loading />}>
        <GoogleOAuthProvider clientId={env("GOOGLE_CLIENT_ID")}>
          <Header>
            <AppRoutes />
          </Header>
        </GoogleOAuthProvider>
      </Suspense>
    </SwitchScreenProvider>
  );
};

export default App;
